export const getLanguageCode = (pathname) => {
  const matcher = new RegExp(/^\/(\w\w)\//);
  const matchingLang = pathname.match(matcher);
  const languageCode = matchingLang && matchingLang[1].trim();
  return languageCode;
};

export const getLanguagePath = (pathname) => {
  const code = getLanguageCode(pathname);
  return code ? `/${code}` : "";
};
